let captcha = require('./captcha').default

module.exports = () => {
    $.expr[':'].contains = $.expr.createPseudo(function (arg) {
        return function (elem) {
            return $(elem).text().toLowerCase().indexOf(arg.toLowerCase()) >= 0;
        };
    });

    $.fn.easyValidate = function(onSuccess, onError, sourceBtn) {
        return this.each(function() {
            let form = $(this)

            $app.maskPhone(form)
            autosize(form.find('textarea'))

            form.on('submit', event => {
                event.preventDefault()

                let button = form.find(':submit:last').prop('disabled', true),
                    buttonText = button.text()

                button.text('Загрузка...')

                $.ajax({
                    type: 'POST',
                    processData: false,
                    contentType: false,
                    url: form.attr('action'),
                    data: new FormData(form[0]),
                    success(json) {
                        if (! json.ret) {
                            if (onError) {
                                return onError.call(form, json, button)
                            } else {
                                return swal.fire('Ошибка :(', json.msg, 'error')
                            }
                        }

                        if (form.data('event')) {
                            let eventData = {}

                            if (form.data('event-param')) {
                                eventData[form.data('event-param')] = $app.barId
                            } else {
                                eventData = $app.barId
                            }

                            $app.runEvent(form.data('event'), eventData)
                        }

                        if (onSuccess) {
                            onSuccess.call(form, json, button)
                        } else {
                            swal.fire('Всё прошло успешно! :)', json.msg, 'success')
                        }

                        if ($.fancybox.getInstance() !== false) {
                            if (sourceBtn) {
                                sourceBtn.data('noLeavePlz', false)
                            }

                            button.text('Закрыть').on('click', () => {
                                $.fancybox.close()

                                return false
                            })
                        }
                    }
                }).always(() => {
                    button.prop('disabled', false)

                    if (button.text() === 'Загрузка...') {
                        button.text(buttonText)
                    }
                })
            })
        })
    };

    $.fn.processBronForm = function(sourceBtn) {
        return this.each(function() {
            let form = this,
                date = form.querySelector('input[name=date]'),
                dateSelect = form.querySelector('.data-list'),
                time = form.querySelector('select[name=time]'),
                amount = form.querySelector('input[name=count]'),
                source = form.querySelector('select[name=source_id]'),
                loadedContent = source?.nextElementSibling,
                loading = (start = true) => {
                    form.classList[start ? 'add' : 'remove']('loading')
                },
                getTime = () => {
                    loading()

                    return $.get($app.urlPrefix + '/bar/bron/getTime', {
                        time: time.value,
                        date: date.value,
                        id: form.dataset.id
                    }, json => {
                        loading(false)

                        time.innerHTML = new DOMParser().parseFromString(json.select, 'text/html').body.firstElementChild.innerHTML

                        let option = dateSelect.querySelector(`option[value="${date.value}"]`)

                        if (json.ret === 0) {
                            time.value = date.value = dateSelect.value = ''

                            if (option && option.disabled === false) {
                                option.disabled = true
                                option.textContent += ' (мест нет)'
                            }

                            swal.fire('Внимание!', json.msg)
                        } else if (! option) { //добавляем новую дату в быстрый список если её в нём ещё нет и только если есть места
                            dateSelect.insertAdjacentHTML('afterbegin', `<option value="${date.value}" selected>${json.date}</option>`)
                        } else {
                            option.selected = true
                        }

                        time.dispatchEvent(new CustomEvent('time.loaded', { detail: json }))
                    })
                },
                getLastRequestContent = (countOfLastDays = 1) => {
                    if (source.value === '') {
                        return loadedContent.innerHTML = '';
                    }

                    loading()

                    $.get($app.urlPrefix + '/bar/bron/lastRequest', {
                        id: form.dataset.id,
                        source_id: source.value,
                        last_days: countOfLastDays
                    }, json => {
                        loading(false)

                        loadedContent.innerHTML = json.content

                        loadedContent.querySelector('select:not([name=last_days])')?.addEventListener('change', event => {
                            let order = json.orders[event.target.value]

                            if (order) {
                                time.addEventListener('time.loaded', () => time.value = order.time, { once: true })

                                date.value = order.date
                                date.dispatchEvent(new Event('change'))

                                amount.value = order.amount
                                amount.dispatchEvent(new Event('input'))
                                amount.previousElementSibling.dispatchEvent(new Event('change'))

                                form.querySelector('input[name=fio]').value = order.fio
                                form.querySelector('input[name=phone]').value = order.phone
                                form.querySelector('input[name=email]').value = order.email || ''
                                form.querySelector('textarea[name=comment]').value = order.comment || ''
                            } else {
                                form.querySelectorAll('input,select:not([name=source_id],[name=hall])').forEach(el => el.value = '')
                            }
                        })

                        loadedContent.querySelector('select[name=last_days]')?.addEventListener('change', event => getLastRequestContent(event.target.value))
                    })
                }

            dateSelect.addEventListener('change', event => {
                if (event.target.value) {
                    event.target.nextElementSibling.value = event.target.value
                    event.target.nextElementSibling.dispatchEvent(new Event('change'))
                } else {
                    date.showPicker()
                }
            })

            date.addEventListener('change', getTime)
            date.dispatchEvent(new Event('change'))
            source?.addEventListener('change', () => getLastRequestContent())
            amount.previousElementSibling.addEventListener('change', e => {
                if (e.isTrusted) {
                    amount.value = e.target.value
                }

                if (! e.target.value) {
                    e.target.classList.add('w-50')
                    e.target.classList.remove('w-100')
                    amount.classList.remove('d-none')

                    if (e.isTrusted) {
                        amount.focus()
                    }
                }
            })
            amount.addEventListener('input', () => {
                amount.previousElementSibling.value = amount.value > parseInt(amount.dataset.limit) ? '' : amount.value
            })
            form.querySelector('.toggle-extend')?.addEventListener('click', event => {
                event.preventDefault()

                let isHidden = event.target.parentNode.nextElementSibling.classList.toggle('d-none')

                event.target.textContent = isHidden ? 'Больше параметров' : 'Меньше параметров'

                $app.runEvent('click', { toggleBronFormExtendedBlock: isHidden ? 'show' : 'hide'})
            })

            if (form.dataset.eventParam.indexOf('choose-table') >= 0) {
                $app.form.chooseTable($(form))
            }

            captcha(form)

            return $(form).easyValidate(json => form.innerHTML = json.msg + (json.msgWelcome || ''), null, sourceBtn)
        })
    };

    $.fn.simpleTabs = function(callback, duration = 200) {
        let getContent = $tab => {
            return $tab.closest('.tab-section').find(`.tab-content[data-id=${$tab.data('id')}]`);
        };

        let handler = ($tab, event) => {
            let eventData = {};

            eventData[$tab.data('event')] = $tab.text().trim();

            $app.runEvent('click', eventData);

            if ($tab.data('tab-lazy') === undefined) {
                $tab.addClass('tabs__item--active');
            }

            $tab.siblings('.tabs__item').removeClass('tabs__item--active');

            $tab.data('content').slideDown(duration, () => {
                $tab.data('content').siblings('.tab-content')
                    .slideUp(duration)
                    .promise()
                    .done(() => {
                        if (typeof callback === 'function') {
                            return callback($tab, event);
                        }
                    });
            });

            return false;
        };

        this.each((i, tab) => {
            let $tab = $(tab),
                $content = getContent($tab);

            $tab.data('content', $content);

            $tab.on('click', event => handler($tab, event));
        });

        let $tabActive = this.filter('.tabs__item--active'),
            $tabsContent = this.closest('.tab-section').find('.tab-content');

        if ($tabActive.length) {
            $tabsContent.hide().filter(`[data-id=${$tabActive.data('id')}]`).show();
        } else if (this.first().data('tab-lazy') === undefined) {
            this.first().addClass('tabs__item--active');
            $tabsContent.not(':first').hide();
        }

        return this;
    };
};